import { useQuery } from '@tanstack/react-query'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useTranslation } from 'react-i18next'

import { PageMeta } from '../../components/common/PageMeta'
import { PhotoStrip } from '../../components/content/PhotoStrip'
import { CardSkeletonGrid, EmptyState, ErrorState, Section } from '../../components/common/States'
import { UnitCard } from '../../components/units/UnitCard'
import { unitsApi } from '../../api/endpoints'
import { useLocale } from '../../i18n/LocaleProvider'

export function HousesPage() {
  const { t } = useTranslation()
  const { locale } = useLocale()

  const units = useQuery({ queryKey: ['units', locale], queryFn: () => unitsApi.list(locale) })

  return (
    <>
      <PageMeta title={t('houses.title')} description={t('houses.subtitle')} path="/houses" />

      <Section title={t('houses.title')} subtitle={t('houses.subtitle')}>
        {units.isPending && <CardSkeletonGrid count={5} />}
        {units.isError && <ErrorState error={units.error} onRetry={() => void units.refetch()} />}
        {units.data?.length === 0 && <EmptyState icon="🏡" title={t('common.notFound')} />}
        {units.data && units.data.length > 0 && (
          <Box
            sx={{
              display: 'grid',
              gap: 3,
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
            }}
          >
            {units.data.map((unit) => (
              <UnitCard key={unit.id} unit={unit} />
            ))}
          </Box>
        )}
      </Section>

      <Section title={t('houses.aroundTheHouses')}>
        <Stack spacing={4}>
          <PhotoStrip category="HOUSE" count={6} />
          <PhotoStrip category="INTERIOR" count={6} showAllLink={false} />
          <PhotoStrip category="SAUNA" count={6} showAllLink={false} />
          {/* The films the owner shot of the cottages. There are three; they are 20 to 60 MB
              each and nothing downloads until one is opened. */}
          <PhotoStrip category="HOUSE" kind="VIDEO" count={6} title={t('gallery.films')} showAllLink={false} />
        </Stack>
      </Section>
    </>
  )
}
